import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const historialInventarioImporterSelectors = importerSelectors(
  'historialInventario.importer',
);

export default historialInventarioImporterSelectors;
